export function customCompare(objA, objB) {
	const matchingObjects = new WeakMap();

	function compareRecursively(objA, objB) {
		if (typeof objA !== typeof objB) {
			return false;
		}

		if (typeof objA !== 'object' || objB === null) {
			return objA === objB || (typeof objA === 'number' && isNaN(objA) && isNaN(objB));
		}

		const matchingObj = matchingObjects.get(objA);

		if (matchingObj) {
			// if objA matches with objB, objA should always match with objB
			return objB === matchingObj;
		}

		// we need to associate objA with objB before checking deeper to
		// ensure that no infinite recursion will occur in the case objA
		// reoccurrence when checking deeper
		matchingObjects.set(objA, objB);

		if (objA.__proto__ !== objB.__proto__) {
			return false;
		} else if (objA instanceof RegExp) {
			return objA.toString() === objB.toString();
		} else if (objA instanceof HTMLElement) {
			return objA.outerHTML === objB.outerHTML;
		} else if (objA instanceof Node) {
			return objA.textContent === objB.textContent;
		} else if (Array.isArray(objA)) {
			if (objA.length !== objB.length) {
				return false;
			}

			for (let i = 0; i < objA.length; ++i) {
				if (!compareRecursively(objA[i], objB[i])) {
					return false;
				}
			}
		} else if (objA instanceof Set) {
			if (objA.size !== objB.size) {
				return false;
			}

			const keysA = objA.keys();
			const keysB = objB.keys();

			while (true) {
				const resA = keysA.next(), resB = keysB.next();

				if (resA.done) {
					break;
				}


				if (!compareRecursively(resA.value, resB.value)) {
					return false;
				}
			}
		} else if (objA instanceof Map) {
			if (objA.size !== objB.size) {
				return false;
			}

			const entriesA = objA.entries();
			const entriesB = objB.entries();

			while (true) {
				const resA = entriesA.next(), resB = entriesB.next();

				if (resA.done) {
					break;
				}


				if (!compareRecursively(resA.value, resB.value)) {
					return false;
				}
			}
		} else {
			for (const key in objA) {
				if (!(key in objB)) {
					return false;
				}
			}

			for (const key in objB) {
				if (!(key in objA) || !compareRecursively(objA[key], objB[key])) {
					return false;
				}
			}
		}

		return true;
	}

	return compareRecursively(objA, objB);
}